import React, { useEffect, useMemo, useRef, useState } from "react";
// import JoditEditor from "jodit-react";
import { createRoot } from "react-dom/client";
import { ChevronLeft } from "lucide-react";
// import Jodit from "jodit";
import JoditEditor, { Jodit } from "jodit-react";
// import { JODIT_CONFIG } from "@/config/jodit-config"; // Your existing config


interface TextEditorProps {
    content: string;
    type: "add" | "edit";
    setContent: (cont: string) => void;
    // placeholders?: { name: string; string: string }[];
    emailTemplateValues: any[] | undefined
    setFocusedField?: (field: "editor") => void;
    focusedField?: "subject" | "editor" | null;
    subjectInputRef?: React.RefObject<{
        triggerSlash?: () => void;
        insertPlaceholder?: (val: string) => void;
    }>;

}

export const JODIT_OPTIONS = {
    buttons: [
        "bold",
        "strikethrough",
        "underline",
        "italic",
        "|",
        "ul",
        "ol",
        "|",
        "outdent",
        "indent",
        "|",
        "font",
        "fontsize",
        "brush",
        "paragraph",
        "|",
        // "image",
        // "video",
        "table",
        // "link",
        "|",
        "align",
        "undo",
        "redo",
        "|",
        "hr",
        "eraser",
        "copyformat",
        "|",
        "fullsize",
        "source",
        "|",
    ],
    buttonsXS: [
        "bold",
        // "image",
        "|",
        "brush",
        "paragraph",
        "|",
        "align",
        "|",
        "undo",
        "redo",
        "|",
        "eraser",
        "dots",
    ],
};

export const JODIT_CONFIG = {
    uploader: {
        insertImageAsBase64URI: false,
        // url: this.userAPIService.getImageURL(),
        url: "", // assign API endpoint to convert media files into s3 url
        // filesVariableName: (e: unknown) => "files",
        imagesExtensions: ["jpg", "png", "jpeg", "gif"],
        headers: {
            Authorization: "Basic aGFyZHlQYXcxMjM0NTpwYXNzMTIzNDU=",
            "access-token": `bearer ${localStorage.getItem("token")}`,
        },
        withCredentials: false,
        prepareData: function (data: FormData) {
            // data.append('id', 24);
            data.delete("path");
            data.delete("source");
            return data;
        },
        isSuccess: function (resp: {
            response: {
                url: string;
            };
        }) {
            console.log("0>>>" + JSON.stringify(resp));
            return resp;
        },
        process: function (resp: {
            response: {
                url: string;
            };
        }) {
            console.log("s>>>" + JSON.stringify(resp.response.url));
            return {
                files: [""],
                isImages: [true],
                baseurl: resp.response.url,
            };
        },
    },
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false,
    addNewLine: false,
    addNewLineOnDBLClick: false,
    buttons: JODIT_OPTIONS.buttons,
    buttonsXS: JODIT_OPTIONS.buttons,
    askBeforePasteFromWord: false,
    askBeforePasteHTML: false,
    limitWords: 1000,
    showPoweredBy: false, // Hide "Powered by Jodit"
    placeholder: "Start...",
    pastePlain: true,
    disablePlugins: ["pasteStorage"],
    defaultActionOnPaste: "insert_only_text" as any,

    events: {

        afterInit(jodit: Jodit) {
            jodit.events.on("toggleFullSize", (isFullSize: boolean) => {
                const existingContainer = document.getElementById(
                    "jodit-back-btn-container"
                );

                if (isFullSize && !existingContainer) {
                    window.history.pushState({ fullscreen: true }, "");
                    // Create container div
                    const btnContainer = document.createElement("div");
                    btnContainer.id = "jodit-back-btn-container";
                    btnContainer.style.position = "fixed";
                    btnContainer.style.top = "10px";
                    btnContainer.style.left = "16px";
                    btnContainer.style.zIndex = "100000";

                    document.body.appendChild(btnContainer);

                    // Render React button in it
                    const root = createRoot(btnContainer);
                    root.render(
                        <button
                            onClick={() => {
                                root.unmount();
                                btnContainer.remove();
                                jodit.toggleFullSize(false);
                            }}
                            className="flex items-center gap-x-1 p-2 rounded-md bg-gray-100 border border-gray-300 text-gray-700 hover:bg-gray-200"
                        >
                            <ChevronLeft />
                        </button>
                    );
                }

                if (!isFullSize && existingContainer) {
                    existingContainer.remove();
                }

            });
            // Track focus when editor is clicked
            jodit.events.on("focus", () => {
                if (typeof window !== "undefined") {
                    (window as any).currentFocusedField = "editor";
                }
            });

            // Create a global trigger method to simulate "/" dropdown trigger
            (window as any).triggerEditorSlash = () => {
                const range = jodit.selection.range;
                if (!range) return;

                const rect = range.getBoundingClientRect();
                const wrapperRect = document
                    .querySelector("#editor-wrapper") // 👈 ID of wrapper div in your component
                    ?.getBoundingClientRect();
                if (!wrapperRect) return;

                // Show dropdown by updating position and state
                // You must expose `setDropdownPos` and `setShowDropdown` globally or via ref
                const top = rect.bottom - wrapperRect.top + 5;
                const left = rect.left - wrapperRect.left;

                // Trigger dropdown show logic
                (window as any).showEditorPlaceholderDropdown?.({ top, left });

                // Optional: clear previous search
                (window as any).setEditorSearchTerm?.("");
            };

        },
    },
};


const DynamicEditor: React.FC<TextEditorProps> = ({
    content,
    setContent,
    type,
    emailTemplateValues,
    setFocusedField,
    // focusedField,
    // subjectInputRef

}) => {

    const editor = useRef<Jodit | null>(null);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });
    const joditInstance = useRef<Jodit | null>(null);
    const editorWrapperRef = useRef<HTMLDivElement>(null);


    const config = useMemo(
        () => ({
            ...JODIT_CONFIG,
            placeholder: type === "add" ? "Type / or use the button to add placeholders..." : "",
            events: {
                ...JODIT_CONFIG.events,
                afterInit(instance: Jodit) {
                    instance.events.on("focus", () => {
                        setFocusedField?.("editor"); // ✅ track editor focus
                    });
                    joditInstance.current = instance;
                    instance.events.on("keydown", (e: KeyboardEvent) => {
                        if (e.key === "/") {
                            setTimeout(() => {
                                // const range = normalizeRange(instance.s.sel.getRangeAt(0));
                                const range = normalizeRange(instance.s.sel?.getRangeAt(0)!);
                               
                                const rect = range.getBoundingClientRect();
                                const wrapperRect = editorWrapperRef.current?.getBoundingClientRect();

                                if (wrapperRect) {
                                    setDropdownPos({
                                        top: rect.bottom - wrapperRect.top + 5,
                                        left: rect.left - wrapperRect.left
                                    });
                                    setShowDropdown(true);
                                    setSearchTerm("");
                                }
                            }, 10);
                        }
                    });
                },
            },
        }),
        []
    );

    // const ensureTextRange = (editor: Jodit): Range => {
    //     const sel = editor.s.sel;
    //     let range = sel.getRangeAt(0);

    //     // If range is already in a text node, return it
    //     if (range.startContainer.nodeType === Node.TEXT_NODE) {
    //         return range;
    //     }

    //     // Create new range at the first available text position
    //     const newRange = document.createRange();
    //     const editable = editor.editor;

    //     // Try to find the first text node in current container
    //     let textNode = findFirstTextNode(range.startContainer);

    //     // If no text node found, use the editor's body
    //     if (!textNode && editable) {
    //         textNode = findFirstTextNode(editable);
    //     }

    //     // If we found a text node, use it
    //     if (textNode) {
    //         newRange.setStart(textNode, 0);
    //         newRange.setEnd(textNode, 0);
    //     }
    //     // Fallback to original range
    //     else {
    //         return range;
    //     }

    //     sel.removeAllRanges();
    //     sel.addRange(newRange);
    //     return newRange;
    // };
const ensureTextRange = (editor: Jodit): Range => {
  const sel = editor?.s?.sel;
  if (!sel || sel.rangeCount === 0) {
    // fallback: create an empty range at the start of the editor
    const fallbackRange = document.createRange();
    const editable = editor?.editor;
    const fallbackNode = editable?.firstChild || editable;

    if (fallbackNode) {
      fallbackRange.setStart(fallbackNode, 0);
      fallbackRange.setEnd(fallbackNode, 0);
    }

    return fallbackRange;
  }

  let range = sel.getRangeAt(0);

  // If range is already in a text node, return it
  if (range.startContainer.nodeType === Node.TEXT_NODE) {
    return range;
  }

  // Create new range at the first available text position
  const newRange = document.createRange();
  const editable = editor.editor;

  // Try to find the first text node in current container
  let textNode = findFirstTextNode(range.startContainer);

  // If no text node found, use the editor's body
  if (!textNode && editable) {
    textNode = findFirstTextNode(editable);
  }

  if (textNode) {
    newRange.setStart(textNode, 0);
    newRange.setEnd(textNode, 0);
  } else {
    return range; // fallback to original range
  }

  sel.removeAllRanges();
  sel.addRange(newRange);
  return newRange;
};

    const findFirstTextNode = (node: Node): Text | null => {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue?.trim()) {
            return node as Text;
        }

        for (let i = 0; i < node.childNodes.length; i++) {
            const found = findFirstTextNode(node.childNodes[i]);
            if (found) return found;
        }

        return null;
    };

    const triggerSlashManually = () => {
        if (!joditInstance.current) return;
        const editor = joditInstance.current;

        editor.s.focus();

        // Ensure we have a proper text range
        ensureTextRange(editor);

        // Insert slash
        editor.selection.insertHTML("/");

        // Calculate position after slight delay
        setTimeout(() => {
            const range = ensureTextRange(editor);
            const rect = range.getBoundingClientRect();
            const wrapperRect = editorWrapperRef.current?.getBoundingClientRect();

            if (wrapperRect) {
                setDropdownPos({
                    top: rect.bottom - wrapperRect.top + 5,
                    left: rect.left - wrapperRect.left
                });
                setShowDropdown(true);
                setSearchTerm("");
            }
        }, 50);
    };

    const normalizeRange = (range: Range): Range => {
        // If range is already in text node, return as-is
        if (range.startContainer.nodeType === Node.TEXT_NODE) {
            return range;
        }

        // Create new range at first text position
        const newRange = document.createRange();
        const textNode = findFirstTextNode(range.startContainer);

        if (textNode) {
            newRange.setStart(textNode, 0);
            newRange.setEnd(textNode, 0);
            return newRange;
        }

        return range;
    };

    useEffect(() => {
        (window as any).triggerEditorSlash = triggerSlashManually;
    }, [triggerSlashManually]);




    const insertPlaceholder = (placeholder: string) => {
        if (!joditInstance.current) return;

        const editor = joditInstance.current;
        editor.s.focus();

        const range = editor.selection.range;
        if (!range) return;

        // Get current selection details
        const node = range.startContainer;
        const offset = range.startOffset;

        // Only proceed if we're in a text node
        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent || '';

            // Check if there's a '/' immediately before cursor
            if (offset > 0 && text[offset - 1] === '/') {
                // Create new text content without the '/'
                const newText = text.substring(0, offset - 1) + text.substring(offset);

                // Replace the text node
                const newTextNode = document.createTextNode(newText);
                if (node.parentNode) {
                    node.parentNode.replaceChild(newTextNode, node);
                }

                // Create new range and set cursor position
                const newRange = document.createRange();
                newRange.setStart(newTextNode, offset - 1);
                newRange.setEnd(newTextNode, offset - 1);
                editor.selection.selectRange(newRange);

                // Now insert the placeholder
                editor.selection.insertHTML(`{{${placeholder}}}`);
            } else {
                // No '/' found, just insert normally
                editor.selection.insertHTML(`{{${placeholder}}}`);
            }
        } else {
            // Not in a text node, just insert normally
            editor.selection.insertHTML(`{{${placeholder}}}`);
        }

        setShowDropdown(false);
    };


    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
                setShowDropdown(false);
                // Don't remove '/' when closing without selection
                joditInstance.current?.s.focus();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);



    useEffect(() => {
        (window as any).showEditorPlaceholderDropdown = (pos: { top: number; left: number }) => {
            setDropdownPos(pos);
            setShowDropdown(true);
        };

        (window as any).setEditorSearchTerm = (val: string) => {
            setSearchTerm(val);
        };
    }, []);



    const filtered = emailTemplateValues?.filter((p) =>
        p.string.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div ref={editorWrapperRef} style={{ position: "relative" }}>
            <JoditEditor
                ref={editor}
                value={content}
                config={config}
                onChange={(newContent) => setContent(newContent)}
            />

            {showDropdown && (
                <div
                    ref={dropdownRef}
                    style={{
                        position: "absolute",
                        top: dropdownPos.top,
                        left: dropdownPos.left,
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        borderRadius: 4,
                        boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
                        minWidth: 200,
                        maxHeight: 200,
                        overflowY: "auto",
                        zIndex: 10000,
                    }}
                    onMouseDown={(e) => e.preventDefault()} // Prevent focus loss
                >
                    <input
                        type="text"
                        autoFocus
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Search placeholders..."
                        style={{
                            padding: "8px",
                            width: "100%",
                            boxSizing: "border-box",
                            borderBottom: "1px solid #eee",
                        }}
                    />
                    <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                        {filtered && filtered.length > 0 ? (
                            filtered.map((item) => (
                                <li
                                    key={item.name}
                                    onMouseDown={(e) => {
                                        e.preventDefault();
                                        insertPlaceholder(`object.${item.name}`);
                                    }}
                                    style={{
                                        padding: "8px 12px",
                                        cursor: "pointer",
                                        borderBottom: "1px solid #f3f3f3",
                                    }}
                                >
                                    {item.string} ({item.name})
                                </li>
                            ))
                        ) : (
                            <li style={{ padding: "8px", color: "#888", fontStyle: "italic" }}>
                                No matches
                            </li>
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
}

DynamicEditor.displayName = "TextEditor";

export default React.memo(DynamicEditor);